import { Breadcrumbs as BreadcrumbsType } from "shared/hooks/useBreadcrumbs";
import { COLOR_GREY_6 } from "shared/theme/colors";
import { ExpandMoreIcon } from "shared/theme/icons/ExpandMoreIcon";
import {
  StyledBreadcrumbsItem,
  StyledBreadcrumbs,
  StyledExpandIcon,
  StyledTypography,
  StyledBreadcrumbIcon,
} from "./styled";

type BreadcrumbsProps = {
  breadcrumbs: BreadcrumbsType;
};

const Breadcrumbs = ({ breadcrumbs }: BreadcrumbsProps) => {
  return (
    <StyledBreadcrumbs
      separator={
        <StyledExpandIcon>
          <ExpandMoreIcon color={COLOR_GREY_6} />
        </StyledExpandIcon>
      }
      aria-label="breadcrumb"
    >
      {breadcrumbs.map((breadcrumb, index) => {
        const isFirst = index === 0;
        const isLast = index === breadcrumbs.length - 1;

        if (isFirst && breadcrumb.icon) {
          return (
            <StyledBreadcrumbsItem
              key="home"
              to={breadcrumb.pathname || "/"}
              shouldBeIcon
            >
              <StyledBreadcrumbIcon>
                <breadcrumb.icon />
              </StyledBreadcrumbIcon>
            </StyledBreadcrumbsItem>
          );
        }

        return breadcrumb.pathname ? (
          <StyledBreadcrumbsItem
            key={breadcrumb.pathname}
            to={breadcrumb.pathname}
          >
            {breadcrumb.title}
          </StyledBreadcrumbsItem>
        ) : (
          <StyledTypography
            variant="bodyMMedium"
            key={breadcrumb.title}
            active={isLast}
          >
            {breadcrumb.title}
          </StyledTypography>
        );
      })}
    </StyledBreadcrumbs>
  );
};

export default Breadcrumbs;
